import uuid from 'uuid';

class Composicao {

    constructor(props){
        this.props =props;
        if(!props.uuid){
            this.props.uuid = uuid.v4();
        }
    }

    get uuid(){
        return this.props.uuid;
    }

    equals(outraComposicao){
        return this.uuid == outraComposicao.uuid;
    }

    toApiJson(){ 
        const {uuid:produto} = this.props.produto.toApiJson();
        const {quantidadeUtilizada, uuid} = this.props;

        return {produto, quantidadeUtilizada, uuid};
    }

    toPlainJson(){

        const {composicao:descartar, ...produto} = this.props.produto.toPlainJson();

        return Object.assign({}, {produto}, {quantidadeUtilizada: this.props.quantidadeUtilizada, uuid: this.props.uuid});
    }
}

const newComposicao = ({produto, quantidadeUtilizada, uuid})=>{
    return new Composicao({produto, quantidadeUtilizada, uuid});
}

export { newComposicao };